
var previousAddresses;

window.initPreviousAddressPicker = function (jsonPreviousAddresses) {

    previousAddresses = JSON.parse(jsonPreviousAddresses);

    $('#paymentSameDropDown').on('change', function () {
        setPrevAddress($('#paymentSameDropDown').val());
    });

    $('#paymentSameCheckbox').on('change', function () {

        if ($('#paymentSameCheckbox').is(':checked')) {

            if (previousAddresses.length === 1) {
                setPrevAddress(0);
            } else {
                $('#paymentSameDropDownContainer').show();
            }

        } else {
            ResetForm();

            if ($('#paymentSameDropDownContainer').is(':visible')) {

                $('#paymentSameDropDownContainer').hide();
                $('#paymentSameDropDown').val('-1');

                if ($('#paymentSameDropDown option:selected').index() != 0) {
                    ResetForm();
                }
            }

            $('#enter-address-manually').removeClass('selected');
            $('#find-address').addClass('selected');
        }
    });
}

function setPrevAddress(i) {

    if (i !== '' && i >= 0) {
        //18022 fix
        if ($('#NameTitle').val() != 'n/a') {
            $('#NameTitle').val(previousAddresses[i].Title);
        }

        $('.selectpicker').each(function () {
            $(this).selectpicker('refresh');
        });

        $('#FirstName').val(previousAddresses[i].FirstName);
        $('#Surname').val(previousAddresses[i].LastName);
        $('#CompanyName').val(previousAddresses[i].CompanyName);
        $('#Address1').val(previousAddresses[i].Address1);
        $('#Postcode').val(previousAddresses[i].PostCode);
        $('#Town').val(previousAddresses[i].Town);
        $('#County').val(previousAddresses[i].County);
        $('#Address2').val(previousAddresses[i].Address2);
        $('#Address3').val(previousAddresses[i].Address3);

        $('#NameTitle').valid();
        $('#FirstName').valid();
        $('#Surname').valid();
        $('#Address1').valid();
        $('#Address2').valid();
        $('#Address3').valid();
        $('#Postcode').valid();
        $('#Town').valid();
        $('#County').valid();

        $('#enter-address-manually').addClass('selected');
        $('#find-address').removeClass('selected');
        EnterAddressManually();
    }
}
